// Generated by CoffeeScript 1.10.0

/*
 * BBCode

Module for parsing BBCode. BBCode is translating into a pseudo-DOM which can
then be translated into "blocks" and then into HTML.

This module is extensible, allowing "new" BBCode to be added. Tags may
optionally take an argument, and closing tags may optionally include the
argument. (So `[list=1][/list=1]` versus `[list=1][/list]`)
 */

(function() {
  var BBCodeParser, BBDocument, BBNode, BBParse, BlockList, SimpleTag, Smiley, TagEvent, TagTokenizer, TextEvent, bbcode, defaultParser, ref, tags,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    slice = [].slice;

  ref = require("./bbdom"), BBDocument = ref.BBDocument, BBNode = ref.BBNode;

  tags = require('./tags');

  BlockList = require('./blocks');

  TagTokenizer = require('./tokenizer');

  SimpleTag = tags.SimpleTag;


  /*
  A Text event, for when the parser discovers text.
   */

  TextEvent = (function() {

    /*
    Create a new Text event.
    @param [BBParse] state the parser generating the event
    @param [String] text the text of the event
     */
    function TextEvent(state, text1) {
      this.state = state;
      this.text = text1;
    }

    return TextEvent;

  })();


  /*
  A Tag event, for when the parser discovers a tag.
   */

  TagEvent = (function() {

    /*
    Create a new Tag event.
    @param [BBParse] state the parser generating the event
    @param [Object] token an internal value
     */
    function TagEvent(state, token) {
      this.state = state;
      this.tag = token.name;
      this.arg = token.arg, this.raw = token.raw;
    }


    /*
    This is a "special" method that indicates that the "current" tag should be
    closed. This only works during the onChildTag event. It's useful any time
    there should be a list of tags that are all children of the parent - which in
    practice is effectively only ever the `[*]` tag. Note that onChildTag must
    return true in order for this to take effect.
     */

    TagEvent.prototype.closeTag = function() {
      return this.closed = true;
    };

    return TagEvent;

  })();


  /*
  Parser state.
   */

  BBParse = (function(superClass) {
    extend(BBParse, superClass);


    /*
    Create a new parser state.
    @param [BBCodeParser] parser the parser which contains information on the
      supported tags.
    @see BBCodeParser#parse
     */

    function BBParse(parser) {
      this.parser = parser;
      this.doc = null;
    }


    /*
    Determines if the given tag is the current tag at the top of the tag stack.
    @param [String] tag the tag to test
    @return [Boolean] whether the given tag was at the top of the tag stack
     */

    BBParse.prototype.isParentTag = function(tag) {
      return this.tagStack.length > 0 && this.tagStack[this.tagStack.length - 1].name === tag.toLowerCase();
    };


    /*
    Determines if the given tags are the tags, in order, that are the top of the
    stack. Note that each tag must be present in order for this to return `true`.
    @param [String] tags an array of tags to test
    @return [Boolean] whether the list of tags at the top of the stack were the
      given tags
     */

    BBParse.prototype.isParentTags = function() {
      var stackIdx, tags, tagsIdx;
      tags = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      if (this.tagStack.length < tags.length) {

      } else {
        tagsIdx = 0;
        stackIdx = this.tagStack.length - 1;
        while (tagsIdx < tags.length) {
          if (this.tagStack[stackIdx].name !== tags[tagsIdx].toLowerCase()) {
            return false;
          }
          tagsIdx++;
          stackIdx--;
        }
        return true;
      }
    };


    /*
    Run the actual parse on an input string. This method must not be called during
    an active parse.
     */

    BBParse.prototype.parse = function(str) {
      var activeTag, child, event, found, i, j, k, l, ref1, ref2, ref3, rv, tag, tok, tokenizer;
      if (this.doc !== null) {
        throw new Error("Do not call parse during an active parse");
      }
      this.doc = new BBDocument();
      tokenizer = new TagTokenizer(str);
      activeTag = null;
      this.tagStack = [];
      this.activeNode = this.doc;
      while (tokenizer.hasNext()) {
        tok = tokenizer.next();
        switch (tok.type) {
          case 'tag':
            tag = this.parser.findTag(tok.name);
            if (tag != null) {
              event = new TagEvent(this, tok);
              if (this.activeNode.onChildTag(event)) {
                if (event.closed === true) {
                  if (this.activeNode === this.doc) {
                    throw new Error("Cannot autoclose document node");
                  }
                  this.tagStack.pop();
                  this.activeNode = this.tagStack[this.tagStack.length - 1].node;
                }
                child = tag.onStartTag(event);
                if (child != null) {
                  this.tagStack.push({
                    'name': tok.name,
                    'tag': tag,
                    'node': child
                  });
                  activeTag = tag;
                  this.activeNode.appendChild(child);
                  this.activeNode = child;
                  continue;
                }
              }
            }
            this.onDeadTag(tok.raw);
            break;
          case 'text':
            this.activeNode.onText(new TextEvent(this, tok.text));
            break;
          case 'endtag':
            found = false;
            if (this.tagStack.length > 0) {
              for (i = k = ref1 = this.tagStack.length - 1; ref1 <= 0 ? k <= 0 : k >= 0; i = ref1 <= 0 ? ++k : --k) {
                if (this.tagStack[i].name === tok.name) {
                  found = true;
                  event = new TagEvent(this, tok);
                  for (j = l = ref2 = this.tagStack.length - 1, ref3 = i; ref2 <= ref3 ? l <= ref3 : l >= ref3; j = ref2 <= ref3 ? ++l : --l) {
                    this.tagStack[j].node.onEndTag(event);
                  }
                  this.tagStack.length = i;
                  if (this.tagStack.length > 0) {
                    this.activeNode = this.tagStack[this.tagStack.length - 1].node;
                  } else {
                    this.activeNode = this.doc;
                  }
                  break;
                }
              }
            }
            if (!found) {
              this.onDeadTag(tok.raw);
            }
        }
      }
      rv = this.doc;
      this.doc = null;
      return rv;
    };


    /*
    Receive notifcation of a "dead" tag - that is a tag that looks like a
    BBCode tag but was rejected, either because it wans't recognized as a known
    tag, or was recognized but the {Tag} class that handled that class rejected
    the event for some reason (such as an invalid argument).
    
    The default version of this method simply inserts the raw text of the dead
    tag into the current active node, which is generally how most BBCode
    implementations do with tags they can't handle for whatever reason.
    @param [String] raw
      the raw text that was rejected
     */

    BBParse.prototype.onDeadTag = function(raw) {
      return this.activeNode.onText(new TextEvent(this, raw));
    };

    return BBParse;

  })(BBNode);


  /*
  A Smiley contains a bunch of information on ways to convert text into a more
  friendly "smiley".
  
  This class isn't really used, but ...
   */

  Smiley = (function() {

    /*
    Create a new Smiley with the given options.
    @param [Object] options
      the options for the smiley
     */
    function Smiley(options) {
      var high, low, patterns;
      this.title = options.title, this.image = options.image, this.emoji = options.emoji, this.match = options.match;
      if ('size' in options) {
        this.imageWidth = options.size[0];
        this.imageHeight = options.size[1];
      }
      if (typeof this.match === 'string') {
        this.regexp = new RegExp(this.match, 'g');
      } else {
        patterns = this.match.map(function(pattern) {
          return pattern.replace(/([\\\[\]^${}.?+*()-])/g, '\\$1');
        });
        this.regexp = new RegExp(patterns.join('|'), 'g');
      }
      if (this.emoji != null) {
        if (typeof this.emoji === 'number') {
          if (this.emoji > 0xFFFF) {
            high = Math.floor((this.emoji - 0x10000) / 0x400) + 0xD800;
            low = (this.emoji - 0x10000) % 0x400 + 0xDC00;
            this.replacement = String.fromCharCode(high) + String.fromCharCode(low);
          } else {
            this.replacement = String.fromCharCode(this.emoji);
          }
        } else {
          this.replacement = this.emoji;
        }
      } else {
        this.replacement = "(oops)";
      }
    }


    /*
    Replace all instances of text that matches the smiley's base text.
    @param [String] text the text to replace
    @return [String] the text with all instances replaced with the replacement
      text
     */

    Smiley.prototype.replace = function(text) {
      return text.replace(this.regexp, this.replacement);
    };

    return Smiley;

  })();

  BBCodeParser = (function() {
    function BBCodeParser(options) {
      var name, tag;
      tags = BBCodeParser.DEFAULT_TAGS;
      if ((options != null ? options.tags : void 0) === "basic") {
        tags = BBCodeParser.BASIC_TAGS;
      }
      this.tags = {};
      for (name in tags) {
        tag = tags[name];
        this.tags[name] = tag;
      }
      this.smileys = BBCodeParser.DEFAULT_SMILIES.slice();
    }

    BBCodeParser.DEFAULT_TAGS = {
      'url': new tags.URLTag(),
      'img': new tags.ImgTag(),
      'quote': new tags.QuoteTag(),
      'code': new tags.CodeTag(),
      'list': new tags.ListTag(),
      '*': new tags.ListItemTag(),
      'b': new SimpleTag("b"),
      'i': new SimpleTag("i"),
      'u': new SimpleTag("u"),
      's': new SimpleTag("strike"),
      'sub': new SimpleTag("sub"),
      'super': new SimpleTag("super")
    };

    BBCodeParser.BASIC_TAGS = {
      'url': new tags.URLTag(),
      'b': new SimpleTag("b"),
      'i': new SimpleTag("i"),
      'u': new SimpleTag("u"),
      's': new SimpleTag("strike"),
      'sub': new SimpleTag("sub"),
      'super': new SimpleTag("super")
    };

    BBCodeParser.DEFAULT_SMILIES = [
      new Smiley({
        "title": "Smile",
        "emoji": 0x1F60A,
        "match": ":-?\\)"
      }), new Smiley({
        "title": "Big Grin",
        "emoji": 0x1F601,
        "match": ":-?D"
      }), new Smiley({
        "title": "Sad",
        "emoji": 0x1F622,
        "match": ":-?\\("
      }), new Smiley({
        "title": "Cool",
        "emoji": 0x1F60E,
        "match": "8-?\\)"
      })
    ];


    /*
    Sets whether or not to use `<em>` and `<strong>` instead of `<i>` and `<b>`.
    It's debatable which is correct.
    
    Note that this modifies the `[i]` and `[b]` tags.
    
    @param [Boolean] useEmStrong `true` to use `<em>` and `<strong>`, `false`
      to use `<i>` and `<b>`
     */

    BBCodeParser.prototype.setUseEmStrong = function(useEmStrong) {
      if (useEmStrong) {
        this.tags['i'] = new SimpleTag("em");
        return this.tags['b'] = new SimpleTag("strong");
      } else {
        this.tags['i'] = BBCodeParser.DEFAULT_TAGS['i'];
        return this.tags['b'] = BBCodeParser.DEFAULT_TAGS['b'];
      }
    };


    /*
    Finds the {Tag} class with the given name.
    
    @param [String] name the name of the tag to look up
    @return [Tag] the Tag object for the tag of that name
     */

    BBCodeParser.prototype.findTag = function(name) {
      name = name.toLowerCase();
      if (name in this.tags) {
        return this.tags[name];
      } else {
        return null;
      }
    };


    /*
    The simplest method of adding a custom BBCode tag, this allows you to provide
    both a start and end bit of HTML to use for the tag.
    
    Note that tags created this way must have a start and end tag.
    
    The default `[b]`, `[i]`, `[u]`, `[s]`, `[super]`, and `[sub]` tags are all
    implemented using (something that could be) this method.
    @param [String] the name of the tag
    @param [String] start the HTML to use before the tag's contents
    @param [String] end the HTML to use after the tag's contents
     */

    BBCodeParser.prototype.addSimpleTag = function(name, start, end, overwrite) {
      if (overwrite == null) {
        overwrite = false;
      }
    };


    /*
    Parses a string containing BBCode, returning a {BBParse} that contains the
    result of the parse.
     */

    BBCodeParser.prototype.parse = function(str) {
      if (str == null) {
        str = "null";
      }
      return new BBParse(this).parse(str.toString());
    };

    BBCodeParser.prototype.replaceSmileys = function(html) {
      var k, len, ref1, smiley;
      ref1 = this.smileys;
      for (k = 0, len = ref1.length; k < len; k++) {
        smiley = ref1[k];
        html = smiley.replace(html);
      }
      return html;
    };

    return BBCodeParser;

  })();

  defaultParser = new BBCodeParser();


  /*
  The main module export function. When you `require 'bbcode'` this is the
  function that's returned as the module.
  
  @overload bbcode(str)
    Parse BBCode, returning HTML.
  
    @param [String] str a string containing the BBCode to parse
    @return [String] a string containing HTML that's the result of the parse
  
  @overload bbcode(obj)
    Create a new {BBCodeParser} with the given options.
  
    @param [Object] obj options to give to {BBCodeParser}
    @return [BBCodeParser] a new `BBCodeParser`
  
  @overload bbcode()
    Return a new {BBCodeParser} that was created with default options.
  
    @return [BBCodeParser] a new BBCodeParser with default options
   */

  bbcode = function(obj) {
    if (obj == null) {
      return new BBCodeParser();
    }
    if (typeof obj === 'object') {
      return new BBCodeParser(obj);
    } else {
      return defaultParser.parse(obj.toString()).toBlocks().toHTML(defaultParser);
    }
  };


  /*
  Don't document the export statement.
  @nodoc
   */

  module.exports = bbcode;


  /*
  The {Tag} class, exported so you can access it via `bbcode.Tag`. This is
  exported to allow the implementation of custom classes.
   */

  exports.Tag = tags.Tag;


  /*
  The {BBCodeParser} class.
   */

  exports.BBCodeParser = BBCodeParser;

  exports.BBNode = BBNode;

  exports.BBDocument = BBDocument;

}).call(this);



/*****************
 ** WEBPACK FOOTER
 ** ./~/bitter-bbcode/lib/bbcode.js
 ** module id = ./node_modules/bitter-bbcode/lib/bbcode.js
 ** module chunks = 1
 **/